if (typeof scrollButton != "undefined" && scrollButton != null) {
    window.addEventListener('resize', () => {
        heroHeight = window.innerHeight;
    });
    scrollButton.addEventListener('click', () => {
        gsap.to(window, {duration: 0.6, ease: "power4.easeInOut", scrollTo: heroHeight});
    });
}